import Magistrado from '@/model/Magistrado';
import { uiStore } from '@/store';
import { mapToPageablePayload } from '@/utils/ApiUtils';
import { RestApi } from '@pjn/ajax/Api';
import { AxiosInstance } from '@pjn/ajax/HttpClient';
import { OptionalId } from '@pjn/core/model/helpers/Types';
import { toEntity } from '@pjn/ajax/helpers';

/** URL base de la API de magistrados */
const MAGISTRADO_URL = process.env.VUE_APP_DENUNCIAS_URL + '/magistrado';

function mapMagistradoFrom(jsonItem: any): Magistrado {
  try {
    jsonItem.id = jsonItem.cuil
    jsonItem.tratamiento = jsonItem.abreviacion
    return jsonItem;
  } catch (e) {
    uiStore.notification.error('Error al cargar el Magistrado');
    console.log('Error realizando el mapeo de Magistrado: ' + e);
    throw new Error(e);
  }
}
function mapMagistradoTo(item: OptionalId<Magistrado>): any {
  try {
    return {
        ...item,     
        cuil: item.id ? item.id : item.cuil

    } as Magistrado;
  } catch (e) {
    console.log('Error realizando mapeo de Magistrado');
    throw new Error('Error realizando mapeo de Magistrado: ' + e);
  }
}

export class MagistradoRestApi extends RestApi<Magistrado> {
  constructor(http: AxiosInstance) {
    super(http, MAGISTRADO_URL);
  }
  save(magistrado: OptionalId<Magistrado>) {
    magistrado = mapMagistradoTo(magistrado);
    return this.http
      .put(`${MAGISTRADO_URL}`, magistrado)
      .then(toEntity<Magistrado>(mapMagistradoFrom))
      .catch(error => {
        uiStore.notification.error(error);
        throw error;
      });
  }
    createMagistrado(magistrado: OptionalId<Magistrado> ) {
    return this.http
      .post(
        `${MAGISTRADO_URL}`, mapMagistradoTo(magistrado) )
      .then(toEntity<Magistrado>(mapMagistradoFrom));
    }

    findById(id: number) {
    return this.http
      .get(`${MAGISTRADO_URL}` + '/' + id)
      .then(toEntity<Magistrado>(mapMagistradoFrom))
      .catch(error => {
        
        return Promise.reject(error);
      });
    }
    
    deleteMagistrado(id: number) {
    return this.http
      .delete(`${MAGISTRADO_URL}` + '/' + id)
      .catch(error => {
        uiStore.notification.error(error);
        return Promise.reject(error);
      });
      
  }
    
  async getMagistrados(query: string) {
    const response = await this.http.get(`${MAGISTRADO_URL}${query}&sort=apellido,asc&sort=nombre,asc`).catch(error => {
      uiStore.notification.error(error.message || error);
      return Promise.reject(error.message || error);
    });
    return mapToPageablePayload<Magistrado>(response.data)
  }

}
